import styled from "styled-components";

export const Main = styled.div`
   position: relative;
   display: block;
   height: 100vh;
   overflow: hidden;
   background: #EDEBFA;
   
   .otherSvg {
      width: 18px;
      height: 18px;

      svg {
         width: 100%;
         height: 100%;
      }
   }
`;